import React, { Component } from 'react';
import { connect } from 'react-redux';
import { BookingSteps, ProcessTypes } from 'fitbeat.gym-core';
import { BaseUserProfile } from 'fitbeat.models';
import { View, Text, StyleSheet, ActivityIndicator } from 'react-native';
import moment from 'moment-timezone';
import { BaseModal, toggleBookingsModal, showToastMessage } from '../../ui';
import {
  BookingView,
  ChangeInvite,
  PartnerSearch,
  ConfirmChangePartnerBooking,
  ConfirmCancelBooking,
  Nickname,
  InvitesReceived,
  WaitlistView,
  ConfirmCancelWaitlistEntry,
  WorkoutSummaryStep,
  setBookingStep,
  resetWizard,
  BookingCompleteStep,
  BookingChanged,
  Metrics,
  CheckIntoFirstBooking,
  SelectEquipment,
  InviteHomeStep,
  OpenInviteReceivedStep,
  GymLocationStep,
  InviteFriendsStep,
  SelectZoneStartTimeStep,
  ClassDurationStep,
  SkillLevelSelectionStep,
  PersonaliseWorkoutSetupStep,
  getNextBookingStep,
  StudioDemoBookingSummaryStep,
  SetupMirrorStep,
  SetupHRMonitorStep,
  ConnectAppleHealthKitStep,
  SetupDefaultHomeEquipmentStep,
  SelectPreferredTimeStep,
  openPersonaliseWorkoutSetupScreen,
  CheckInStep,
  TypeOfWorkoutWarningStep,
  LiveStreamOptionsStep,
  BagContactStep,
} from '../../Bookings';
import Theme from '../../theme';
import { getGymTimezone } from '../../utils/gyms';
import { Logger } from '../../utils';
import { translate } from 'react-i18next';
import SelectOnDemandStudioTimeSlot from '../../Bookings/steps/SelectOnDemandStudioTimeSlot';
import { 
  setWorkoutSession, 
  cancelBookingConfirmed, 
} from '../../Bookings/actions';
import { cancelWorkoutBooking } from '../../Bookings/steps/ConfirmCancelBooking';

class BookingWizardComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      workoutInviteStartTime: props.workoutInviteStartTime,
    }
  }

  closeModal = async () => {
    const {
      userProfile,
      toggleBookingsModal,
      workoutSessionService,
      workoutSession,
      currentBookingStep,
      setBookingStep,
      resetWizard,
    } = this.props;

    if (currentBookingStep === BookingSteps.BookingView 
      && this.props.bookingWizard?.onDemandStudioBooking) {

      this.setState({ isLoading: true });

      await cancelWorkoutBooking({
        userProfile,
        workoutSession,
        workoutSessionService,
        setWorkoutSession: this.props.setWorkoutSession,
        getNextBookingStep: this.props.getNextBookingStep,
        cancelBookingConfirmed: this.props.cancelBookingConfirmed,
        showToastMessage: this.props.showToastMessage, 
        setIsLoading: (isLoading) => this.setState({ isLoading })
      });
      
      return;
    }

    if (currentBookingStep === BookingSteps.CustomiseWorkout) {
      this.props.openPersonaliseSetupScreen('Dashboard')
      this.props.getNextBookingProcessStep(userProfile, ProcessTypes.WorkoutSettings)
      return;
    }
    resetWizard(userProfile);
    try {
      if (workoutSession && (
        currentBookingStep === BookingSteps.WorkoutSettingsOverview ||
        currentBookingStep === BookingSteps.SelectEquipment ||
        currentBookingStep === BookingSteps.MedicalCheck)) {
        await this.setState({ isLoading: true });
        await workoutSessionService.cancelBooking(workoutSession.uniqueReference);
        setBookingStep(null);
      }
    } catch (error) {
      Logger.notify(error);
    } finally {
      await this.setState({ isLoading: false });
      toggleBookingsModal(false);
      workoutSessionService.getMyCurrentBookings();
    }
  }

  getBookingView = (bookingStep) => {
    const { userProfile } = this.props;

    switch (bookingStep) {
      case BookingSteps.BookingView:
        return BookingView;
      case BookingSteps.WorkoutSettingsOverview:
        return WorkoutSummaryStep;
      case BookingSteps.ChangeInvite:
        return ChangeInvite;
      case BookingSteps.PartnerSearch:
        return PartnerSearch;
      case BookingSteps.ConfirmChangeForPartnerBooking:
        return ConfirmChangePartnerBooking;
      case BookingSteps.ConfirmCancelBooking:
        return ConfirmCancelBooking;
      case BookingSteps.CustomiseWorkout:
        return PersonaliseWorkoutSetupStep;
      case BookingSteps.TypeOfWorkoutWarning:
        return TypeOfWorkoutWarningStep;
      case BookingSteps.Nickname:
        return Nickname;
      case BookingSteps.InvitesRecieved:
        return InvitesReceived;
      case BookingSteps.OpenInvitesReceived:
        return OpenInviteReceivedStep;
      case BookingSteps.ConfirmCancelWaitlist:
        return ConfirmCancelWaitlistEntry;
      case BookingSteps.WaitlistView:
        return WaitlistView;
      case BookingSteps.SkillLevel:
        return SkillLevelSelectionStep
      case BookingSteps.SelectEquipment:
        return SelectEquipment;
      case BookingSteps.BookingComplete:
        return BookingCompleteStep
      case BookingSteps.BookingChanged:
        return BookingChanged;
      case BookingSteps.Metrics:
        return Metrics
      case BookingSteps.CheckIntoFirstBooking:
        return CheckIntoFirstBooking
      case BookingSteps.InviteHome:
        return InviteHomeStep;
      case BookingSteps.GymLocation:
        return GymLocationStep;
      case BookingSteps.InviteFriends:
        return InviteFriendsStep;
      case BookingSteps.SelectStartTime:
        return SelectZoneStartTimeStep
      case BookingSteps.SelectStartDate:
        return SelectPreferredTimeStep;
      case BookingSteps.ClassDuration:
        return ClassDurationStep;
      case BookingSteps.SetupMirror:
        return SetupMirrorStep;
      case BookingSteps.SetupHRMonitor:
        return SetupHRMonitorStep;
      case BookingSteps.ConnectAppleHealthKit:
        return ConnectAppleHealthKitStep;
      case BookingSteps.SetupDefaultHomeEquipment:
        return SetupDefaultHomeEquipmentStep;
      case BookingSteps.DemoStudioBookingSummary:
        return StudioDemoBookingSummaryStep;
      case BookingSteps.BagContact:
        return BagContactStep;
      case BookingSteps.CheckIn:
        return CheckInStep;
      case BookingSteps.LiveStreamOptions:
        return LiveStreamOptionsStep;
      case BookingSteps.SelectOnDemandStudioSlot:
        return SelectOnDemandStudioTimeSlot;
      default:
        return null;
    }
  };

  getModalTitle = (Component) => {
    if (!Component.getTitle) {
      return <></>;
    }

    const {
      t,
      day,
      workoutSession,
      waitlistEntry,
      longTermGoal,
      isCustomisingWorkout,
      isInstant,
      processType,
    } = this.props;
    if (!day) {
      return '';
    }
    let date = day.date;
    if (workoutSession) {
      date = workoutSession.startTimeOfFirstExercise;
    } else if (waitlistEntry) {
      date = waitlistEntry.timeSlot.startTime;
    }
    const gymTimezone = getGymTimezone(workoutSession);
    const closeModal = this.closeModal;

    return Component.getTitle({
      t,
      date,
      gymTimezone,
      longTermGoal,
      isCustomisingWorkout,
      isInstant,
      closeModal,
      processType,
    });
  }

  getModalSubtitle = (Component) => {
    const { workoutInviteStartTime } = this.state;
    const {
      day,
      workoutSession,
      waitlistEntry,
      userProfile,
      workoutSessionService,
    } = this.props;
    if (!day) {
      return null;
    }
    const gymTimezone = workoutSession ? getGymTimezone(workoutSession) : moment.tz.guess();
    if (Component.getSubtitle) {
      return Component.getSubtitle({
        day,
        workoutSession,
        gymTimezone,
        waitlistEntry,
        userProfile,
        workoutSessionService,
        workoutInviteStartTime,
      });
    }
    return null;
  }

  renderBookingCancellationLoading = () => {
    const { t } = this.props;
    return (
      <View style={styles.loadingContainer}>
        <Text style={styles.cancelling}>{t('deletingWorkout')}</Text>
        <ActivityIndicator
          size="small"
          color={Theme.PRIMARY}
          animating={true}
          style={styles.activityIndicator}
        />
      </View>
    );
  }

  render() {
    const {
      day,
      userProfile,
      currentBookingStep,
      userProfileService,
      workoutSessionService,
      waitingListServiceClient,
      isBookingModalVisible,
      processType,
    } = this.props;
    const { isLoading } = this.state;
    const Component = this.getBookingView(currentBookingStep);

    if (!Component) {
      return null;
    }

    const overrideModalPadding = [
      BookingSteps.WorkoutSettingsOverview,
      BookingSteps.TypeOfWorkoutWarning,
      BookingSteps.BookingView,
      BookingSteps.SetupHRMonitor,
      BookingSteps.WaitlistView,
      BookingSteps.OpenInvitesReceived,
      BookingSteps.DemoStudioBookingSummary,
      BookingSteps.SelectStartTime,
    ].includes(currentBookingStep)

    const hideModalCloseButton = [
      BookingSteps.WorkoutSettingsOverview,
      BookingSteps.TypeOfWorkoutWarning,
      BookingSteps.BookingView,
      BookingSteps.SetupMirror,
      BookingSteps.SetupHRMonitor,
      BookingSteps.WaitlistView,
      BookingSteps.OpenInvitesReceived,
      BookingSteps.SelectOnDemandStudioSlot,
      BookingSteps.SelectStartTime,
    ].includes(currentBookingStep) || processType === 'DemoStudioBooking';

    const useSafeAreaViewModalContainer = ![
      BookingSteps.WorkoutSettingsOverview,
      BookingSteps.BookingView,
      BookingSteps.SetupHRMonitor,
      BookingSteps.WaitlistView,
      BookingSteps.OpenInvitesReceived,
    ].includes(currentBookingStep)

    const title = this.getModalTitle(Component);
    const subtitle = this.getModalSubtitle(Component);

    const bookingProcessInsideNarrowAuthContainerOnWeb = processType === 'DemoStudioBooking'

    return (
      <BaseModal
        title={title}
        subtitle={subtitle}
        closeIconSize={35}
        closeModal={this.closeModal}
        showHeader={true}
        bodyStyle={overrideModalPadding ? { paddingHorizontal: 0, paddingVertical: 0 } : null}
        isModalVisible={isBookingModalVisible}
        containerStyle={styles.containerStyle}
        hideCloseButton={hideModalCloseButton}
        useSafeAreaView={useSafeAreaViewModalContainer}
        useFullWidth={bookingProcessInsideNarrowAuthContainerOnWeb}
      >
        <View style={styles.modalContainer}>
          {isLoading
            ?
            this.renderBookingCancellationLoading()
            :
            <Component
              day={day}
              userProfile={userProfile}
              waitingListServiceClient={waitingListServiceClient}
              userProfileService={userProfileService}
              workoutSessionService={workoutSessionService}
              closeModal={this.closeModal}
            />
          }
        </View>
      </BaseModal>
    )
  }
}

const styles = StyleSheet.create({
  modalContainer: {
    flex: 1,
  },
  containerStyle: {
    height: '100vh',
  },
  headerContainer: {
    flexDirection: 'row',
    flex: 1,
    alignItems: 'flex-end',
  },
  textContainer: {
    flexDirection: 'row',
  },
  loadingContainer: {
    flex: 1,
    justifyContent: 'center',
  },
  cancelling: {
    fontFamily: Theme.Custom500,
    textAlign: 'center',
    fontSize: 20,
    color: Theme.CHARCOAL,
    paddingVertical: 10,
  },
  progressBar: {
    marginTop: 10,
  },
});

const mapStateToProps = (state) => {
  let { workoutInviteStartTime } = state.deepLinkParamaters;
  workoutInviteStartTime = workoutInviteStartTime ? parseInt(workoutInviteStartTime, 10) : undefined;
  return {
    isBookingModalVisible: state.bookings.bookingWizard.isBookingModalVisible,
    currentBookingStep: state.bookings.bookingWizard.currentBookingStep,
    workoutSession: state.bookings.bookingWizard.workoutSession,
    waitlistEntry: state.bookings.bookingWizard.waitlistEntry,
    longTermGoal: state.bookings.bookingWizard.longTermGoal,
    workoutInviteStartTime,
    progressBar: state.bookings.bookingWizard.progressBar,
    isCustomisingWorkout: state.bookings.bookingWizard.isCustomisingWorkout,
    day: state.bookings.bookingWizard.day,
    processType: state.bookings.bookingWizard.processType,
    isInstant: state.bookings.bookingWizard.pendingSlot &&
      state.bookings.bookingWizard.pendingSlot.isInstant,
    bookingWizard: state.bookings.bookingWizard,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    toggleBookingsModal: (visible) => dispatch(toggleBookingsModal(visible)),
    setBookingStep: (booking) => dispatch(setBookingStep(booking)),
    resetWizard: (userProfile) => dispatch(resetWizard(userProfile)),
    getNextBookingProcessStep: (userProfile, processType) =>
      dispatch(getNextBookingStep(userProfile, processType, undefined, undefined)),
    openPersonaliseSetupScreen: (screen) =>
      dispatch(openPersonaliseWorkoutSetupScreen(screen)),
    setWorkoutSession: (booking) => dispatch(setWorkoutSession(booking)),
    cancelBookingConfirmed: (workoutSessions, userProfile) => 
      dispatch(cancelBookingConfirmed(workoutSessions, userProfile)),
    getNextBookingStep: (userProfile, processType) => 
      dispatch(getNextBookingStep(userProfile, processType)),
    showToastMessage: (message) => dispatch(showToastMessage(message)),
  };
};

BookingWizardComponent = translate(['bookings', 'dashboard'],
  { wait: true })(connect(mapStateToProps, mapDispatchToProps)(BookingWizardComponent));
export const BookingWizard = BookingWizardComponent;
